import { render } from "./folders.vue?vue&type=template&id=09135d8d"
import script from "./folders.vue?vue&type=script&lang=js"
export * from "./folders.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__